import posthog from "posthog-js";

export function initPostHog() {
  const key = import.meta.env.VITE_POSTHOG_KEY as string | undefined;
  if (!key) return; // skip in local dev unless key is set

  posthog.init(key, {
    api_host: import.meta.env.VITE_POSTHOG_HOST ?? "https://us.i.posthog.com",
    person_profiles: "identified_only",
    capture_pageview: false, // we fire manually so React Router routes are tracked
    capture_pageleave: true,
    autocapture: true,
    session_recording: {
      maskAllInputs: true, // never record passwords or payment fields
    },
  });
}

/** Identify a logged-in user. Call after login/signup. */
export function identifyUser(id: string, props?: Record<string, unknown>) {
  posthog.identify(id, props);
}

/** Reset identity on logout. */
export function resetUser() {
  posthog.reset();
}

/** Fire a page-view event. Call from a React Router location watcher. */
export function trackPageView(path: string) {
  posthog.capture("$pageview", { $current_url: path });
}

/** Fire a named product event. */
export function track(event: string, props?: Record<string, unknown>) {
  posthog.capture(event, props);
}

export { posthog };
